import { useEffect, useRef, useState } from 'react';

/**
 * Manages tab state with a one-time default override.
 * When `shouldDefault` becomes true, switches to `defaultTab` once.
 */
export function useTabNav<T extends string>(
  initialTab: T,
  shouldDefault: boolean,
  defaultTab: T
): [T, (tab: T) => void] {
  const [activeTab, setActiveTab] = useState<T>(initialTab);
  const hasDefaulted = useRef(false);

  useEffect(() => {
    if (shouldDefault && !hasDefaulted.current) {
      hasDefaulted.current = true;
      setActiveTab(defaultTab);
    }
  }, [shouldDefault, defaultTab]);

  return [activeTab, setActiveTab];
}
